enum EmailNotificationType {
  ORDER_CONFIRMATION = "orderconfirmation",
  ORDER_CAPTURED = "ordercaptured",
  ORDER_SHIPPED = "ordershipped",
  ORDER_CANCELLED = "ordercancelled",
  ORDER_EDITED = "orderedited",
  ORDER_READY_FOR_PICKUP = "orderreadyforpickup",
  ORDER_INVOICE = "orderinvoice",
  CUSTOMER_RESET_PASSWORD = "customer_reset_password",
  CUSTOMER_ACTIVATE_ACCOUNT = "customer_activate_account",
  CUSTOMER_WELCOME_ACCOUNT = "customer_welcome_account",
  ABANDONED_CHECKOUT_RECOVER = "abandonedcheckoutrecover",
}

export default EmailNotificationType;
